export default __webpack_public_path__ + "static/media/fridge1-before1-1440w.45b94ce8.webp";